import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { PermissionUtil } from "../shared/utils/permission.util";

export function permissionGuard(module: string, action = "read"): CanActivateFn {
  return () => {
    const router = inject(Router);
    if (PermissionUtil.can(module, action)) {
      return true;
    }
    router.navigate([PermissionUtil.getLandingRoute()]);
    return false;
  };
}
